import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface MachineCardProps {
  id: string;
  brand?: string;
  model?: string;
  variant?: string;
  brandLink?: string;
  modelLink?: string;
  variantLink?: string;
  type?: 'supported' | 'original';
  onDelete?: (machineId: string) => void;
}

export default function MachineCard({
  id,
  brand,
  model,
  variant,
  brandLink,
  modelLink,
  variantLink,
  type,
  onDelete,
}: MachineCardProps) {
  return (
    <Card className="overflow-hidden hover:shadow-md transition-shadow">
      <CardContent className="p-5">
        <div className="flex justify-between items-start">
          <div className="space-y-3 w-full">
            <div className="flex justify-between items-center w-full">
              <h3 className="font-semibold text-lg line-clamp-1">
                <a href={brandLink} target="_blank" rel="noreferrer">
                  {brand}
                </a>
              </h3>
              {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
              {type === 'original' ? <Badge>Machine Created On</Badge> : <></>}
              {onDelete && (
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-red-500 hover:text-red-700 hover:bg-red-50 h-8 w-8 p-0 rounded-full"
                  onClick={() => onDelete?.(id)}
                  aria-label="Delete machine"
                >
                  <X className="h-4 w-4" />
                </Button>
              )}
            </div>

            <div className="grid grid-cols-3 gap-2 text-sm">
              {model && (
                <div className="space-y-1">
                  <p className="text-muted-foreground">Model</p>
                  <Badge variant="outline" className="font-medium">
                    <a href={modelLink} target="_blank" rel="noreferrer">
                      {model}
                    </a>
                  </Badge>
                </div>
              )}

              {variant && (
                <div className="space-y-1">
                  <p className="text-muted-foreground">Variant</p>
                  <Badge variant="outline" className="font-medium">
                    <a href={variantLink} target="_blank" rel="noreferrer">
                      {variant}
                    </a>
                  </Badge>
                </div>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
